import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Plan from "./Plan";
import { ImCross } from "react-icons/im";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import Local from '../assets/images/local.svg';

const BuyUKplan = () => {
  const [plans, setPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selected,setSelected]=useState();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No token found. Please log in.');
      setLoading(false);
      return;
    }

    axios.get('https://esimgo.clay.in/api/ESIM/Get_all_plansofUK?flag=1', {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      if (response.data.isSuccess) {
        const sortedPlans = response.data.getallplan.sort((a, b) => {
          if (a.data === null) return 1;
          if (b.data === null) return -1;
          return a.data > b.data ? 1 : a.data < b.data ? -1 : 0;
        });
        setPlans(sortedPlans);         // 🔥 Full plans, no slice
        setFilteredPlans(sortedPlans); // 🔥 Full plans for search
      } else {
        setError('Failed to fetch data.');
      }
    })
    .catch((error) => {
      setError('Error fetching plans: ' + error.message);
    })
    .finally(() => {
      setLoading(false);
    });
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    
    const filtered = plans.filter((plan) =>
      plan.planname.toLowerCase().includes(query)
    );
    setFilteredPlans(filtered);
  };

  const handleBuyClick = (plan) => {
    localStorage.setItem("planCode", plan.plancode);
    localStorage.setItem("plan_id", plan.planid);

    setSelectedPlan(plan);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const handleNavigation = (storeType) => {
    setSelected(storeType);

    if (storeType === "local") {
      navigate("/Buydataukthailand"); // Navigate to Home
    } else if (storeType === "regional") {
      navigate("/BuyDataRegional"); // Navigate to Regional eSIM
    } else if (storeType === "customplan") {
      navigate("/InventoreCustomPlan"); // Navigate to Regional eSIM
    }  else if (storeType === "Buyukplan") {
      navigate("/Buyukplan"); // Navigate to Regional eSIM
  }  else{
      navigate("/BuyDataGlobal")
    }
  };
  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
<div>
    <div className="flex ">
    <button onClick={() => handleNavigation("local")} className={` rounded-lg h-10 flex flex-row items-center  p-2  border border-gray-600  m-2 `}>
      <img src={Local} className={`h-6 w-6 filter invert sepia saturate-500 hue-rotate-180 brightness-150 contrast-100mr-2 ${selected === "local" ? "text-brand-green-selected" : "text-gray-400"}`}  alt="Uk Image"/>
      Local eSIM store
    </button>
      <button onClick={() => handleNavigation("Buyukplan")} className={` rounded-lg h-10 flex flex-row items-center  p-2  border border-gray-600  m-2 ${
              selected === "Buyukplan"? "bg-brand-white text-brand-green-selected": "bg-brand-green-selected text-brand-white"}`}      >
            <img src={Local} className={`h-6 w-6  mr-2 ${selected === "Buyukplan" ? "text-brand-green-selected" : "text-gray-400"}`} alt="uk Image"/>
            eSIM Cards Plan
     </button>
</div>
    <div className="mt-4 p-4 border rounded-md bg-gray-100 max-h-[600px] overflow-y-auto">
   
      {/* Heading and Search Bar */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-5xl font-bold">UK eSIM Plans</h2>
        <input
          type="text"
          placeholder="Search plan..."
          value={searchQuery}
          onChange={handleSearch}
          className="p-2 border border-gray-400 rounded-md focus:outline-none"
        />
      </div>

      <table className="w-full">
        <thead className="sticky top-15 bg-gray-200">
          <tr className="border-b">
            <th className="text-center p-3 px-5">Plan Name</th>
            <th className="text-center p-3 px-5">Data</th>
            <th className="text-center p-3 px-5">Validity</th>
            <th className="text-center p-3 px-5">Operator</th>
            <th className="text-center p-3 px-5">Plan Class</th>
            <th className="text-center p-3 px-5">Selling Cost</th>
            <th className="text-center p-3 px-5">Buy</th>
          </tr>
        </thead>
        <tbody className="border-b hover:bg-gray-200">
          {filteredPlans.length > 0 ? (
            filteredPlans.map((plan, index) => {
              const conversionRate = 1.25866;
              return (
                <tr key={index} className="bg-gray-100">
                  <td className="text-center p-3">{plan.planname}</td>
                  <td className="text-center p-3">{plan.data || "Unlimited"}</td>
                  <td className="text-center p-3">{plan.validity}</td>
                  <td className="text-center p-3">{plan.operatorname}</td>
                  <td className="text-center p-3">{plan.plan_Class}</td>
                  <td className="text-center p-3">${plan.sellingcost}</td>
                  <td className="text-center">
                    <button
                      className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected border-blue-500 h-10 flex flex-row items-center justify-center p-4 box-border text-brand-white m-4"
                      onClick={() => handleBuyClick(plan)}
                    >
                      Buy
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-center p-4 text-red-500 font-bold">
                No plans found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: { width: "80%", margin: "auto", padding: "0px", borderRadius: "8px", height: "fit-content" },
        }}
      >
        <div className="absolute top-4 right-5 flex justify-center items-center">
          <button onClick={closeModal} className="text-black">
            <ImCross size={20} />
          </button>
        </div>
        {selectedPlan && <Plan plan={selectedPlan} closeModal={closeModal} />}
      </Modal>
    </div>
    </div>
  );
};

export default BuyUKplan;
